<!--
 * @Author: ZS
 * @Date: 2020-06-24 11:28:35
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-16 11:09:46
 * @Description: file content
-->
<template>
  <div>
    <div class="input-group ywtbSearch">
      <input type="text" class="form-control" placeholder="请输入您要搜索的关键词" v-model="inputVal" @keyup.enter="search()">
      <span class="input-group-btn" @click="search()">
        <button class="btn" type="button">搜索</button>
      </span>
    </div>
    <div class="hotSearch clearfix">
      <b>热门搜索：</b>
      <ul class="clearfix">
        <li class="noselect" v-for="(item,index) in hotItems" :key="index"
          @click="searchHot(item.pcGuidelineHotSearchWord)">{{item.pcGuidelineHotSearchWord}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        hotItems: '',
        inputVal: ''
      }
    },
    mounted() {
      this.getHotItems()
    },
    methods: {
      // 获取热词搜索
      getHotItems() {
        let sendData = qs.stringify({
          pageNum: 1,
          pageSize: 5
        })
        this.ywtbRequest('/portal-ywtb/web/portalPcGuidelineHotSearch/findPortalPcGuidelineHotSearchList',
          sendData).then(res => {
          let data = res.dataList
          this.hotItems = data
        })
      },
      search() {
        localStorage.setItem('searchVal', this.inputVal)
        this.$router.push('/search')
      },
      searchHot(data) {
        localStorage.setItem('searchVal', data)
        this.$router.push('/search')
      },
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page/home/SearchBar.vue